module.exports = __webpack_public_path__ + "img/2_no.ffa47c56.svg";